import { Modal } from '@bp/ui-components';
import type { BpClassType } from 'pages/Institution/subpages/InstitutionClassesSubpage';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClassProfilesForm } from '../forms/ClassProfilesForm';

export type ClassesProfileModalProps = {
  isOpen: boolean;
  bpClass: BpClassType;
  schoolYearUuid: string;
  onClose: () => void;
};

export const ClassProfilesModal = ({ isOpen, bpClass, schoolYearUuid, onClose }: ClassesProfileModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} title={t('classes.assignClassProfiles')} isOpen={isOpen} onRequestClose={onClose}>
      <ClassProfilesForm bpClass={bpClass} schoolYearUuid={schoolYearUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
